exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dateFormatSelect[data-v-51cd1576] {\n  width: fit-content;\n  display: inline;\n}\n.tagBtnGrpAdjustment[data-v-51cd1576] {\n  min-width: calc(100vw - 470px);\n}\n.tagBtnGrp.btn-group[data-v-51cd1576] {\n  max-width: calc(100vw - 470px);\n}\n", ""]);

// exports
